<i18n>
{
  "fr": {
    "notes-form-notes-placeholder": "Note de suivi",
    "indicator-general-note-form-cancel-btn": "Annuler",
    "indicator-general-note-form-submit-btn": "Sauvegarder la note",
    "indicator-general-note-form-add-btn": "Ajouter une note de suivi",
    "indicator-general-note-form-edit-btn": "Éditer la note de suivi"
  },
  "en": {
    "notes-form-notes-placeholder": "Notes",
    "indicator-general-note-form-cancel-btn": "Cancel",
    "indicator-general-note-form-submit-btn": "Save the note",
    "indicator-general-note-form-add-btn": "Add a note",
    "indicator-general-note-form-edit-btn": "Edit the note"
  }
}
</i18n>

<template>
  <div v-if="hasNotes">
    <div v-if="!showForm">
      <!-- Bouton editer/ajouter -->
      <b-button
        type="is-text has-text-link has-text-decoration-none"
        @click="toggleForm(true)"
        outlined
        size="is-small"
        icon-left="edit"
        style="margin-left: -6px"
        :disabled="readOnly"
      >
        {{ addEditBtnLabel }}
      </b-button>
      <slot name="update"></slot>
    </div>

    <!-- Formulaire d'édition/ajout -->
    <s-form
      v-if="showForm"
      @submit="(ev) => fireNotesEdited()"
      ref="notesForm"
      class="notes-form__form"
      :class="{ 'notes-form__form--absolute': isAbsolutePos }"
    >
      <!-- Notes -->
      <s-field :value="editedNotes">
        <b-input type="textarea" size="is-small" v-model="editedNotes" :placeholder="$t('notes-form-notes-placeholder')" />
      </s-field>

      <!-- Boutons -->
      <div>
        <b-button type="is-link" size="is-small" outlined native-type="button" class="mr-12px" @click="toggleForm(false)">
          {{ $t('indicator-general-note-form-cancel-btn') }}
        </b-button>
        <b-button type="is-link" size="is-small" native-type="submit">
          {{ $t('indicator-general-note-form-submit-btn') }}
        </b-button>
      </div>
    </s-form>
  </div>
</template>

<script>
import SForm from '@/components/form/form'
import SField from '@/components/form/field'

export default {
  components: { SForm, SField },
  props: {
    notes: String,
    readOnly: Boolean,
    isAbsolutePos: Boolean
  },
  data() {
    return {
      showForm: false,
      editedNotes: ''
    }
  },
  computed: {
    addEditBtnLabel() {
      return !this.notes ? this.$t('indicator-general-note-form-add-btn') : this.$t('indicator-general-note-form-edit-btn')
    }
  },
  methods: {
    toggleForm(show) {
      this.showForm = show
      this.editedNotes = this.notes
      this.$emit('toggleShowForm', show)
    },
    fireNotesEdited() {
      if (!this.$refs.notesForm.validate()) return

      this.$emit('onSaveNotes', this.editedNotes)
      this.toggleForm(false)
    },
    hasNotes() {
      return this.notes
    }
  }
}
</script>

<style lang="scss" scoped>
@include desktop {
  .notes-form {
    &__form {
      &--absolute {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
      }
    }
  }
}
</style>
